export default __webpack_public_path__ + "static/media/about_left.fd6eb46c.png";